<template>
	<div data-test="asset-details-market-info">
		<h2 class="heading-5">Location</h2>
		<div v-if="location" class="text-color-content-secondary">{{ location }}</div>
		<AssetElementMap class="mt-100" :asset-elements="assetCard" :custom-zoom="8" :set-height="264" />
	</div>
</template>

<script setup lang="ts">
import { Asset } from 'types/assets';
import AssetElementMap from '@components/asset-element/asset-element-map.vue';
import { computed } from 'vue';

interface Props {
	asset: Asset;
}

const props = defineProps<Props>();

const location = computed((): string => {
	const city = props.asset.realEstateAndPrivateCreditFields?.city;
	const state = props.asset.realEstateAndPrivateCreditFields?.state;

	if (city && state) {
		return `${city}, ${state}`;
	} else {
		return '';
	}
});

const assetCard = computed(
	(): Array<Asset> =>
		[
			{
				...props.asset,
				realEstateAndPrivateCreditFields: {
					...props.asset.realEstateAndPrivateCreditFields,
					city: undefined,
					state: undefined,
					zipCode: undefined
				}
			}
		] as Array<Asset>
);
</script>

<style lang="scss">
@use '../../../styles/constants/config.scss' as *;

[data-test='asset-details-market-info'] {
	.map-container {
		border-radius: $module-border-radius;
	}
}
</style>
